/**
 * FounderStoryModal \u2014 the full polished founder story (Spec Section 7),
 * rendered verbatim. Opens from the Supporting Section 5 teaser link and from
 * any other founder-story CTA on the page.
 */
import { useEffect } from "react";
import { X } from "lucide-react";
import { FOUNDER_STORY } from "../lib/copy";

export const FounderStoryModal = ({ open, onClose }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      data-testid="founder-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="founder-modal-title"
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-3 sm:p-6"
      style={{ background: "rgba(42, 36, 32, 0.55)", backdropFilter: "blur(4px)" }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="ss-panel relative w-full max-w-2xl max-h-[92vh] overflow-y-auto"
        style={{ borderColor: "var(--ss-rule-line)" }}
      >
        <button
          onClick={onClose}
          data-testid="founder-modal-close"
          aria-label="Close founder story"
          className="absolute top-4 right-4 p-1.5 rounded-full hover:bg-black/5"
          style={{ color: "var(--ss-muted)" }}
        >
          <X className="w-5 h-5" strokeWidth={2.25} />
        </button>

        <div className="p-6 sm:p-9">
          <p
            className="ss-eyebrow mb-2"
            style={{ color: "var(--ss-gold-deep)" }}
          >
            Founder story
          </p>
          <h2
            id="founder-modal-title"
            className="ss-display-tight text-3xl sm:text-4xl leading-tight mb-6"
            data-testid="founder-modal-title"
            style={{ color: "var(--ss-ink)" }}
          >
            {FOUNDER_STORY.title}
          </h2>

          <div className="space-y-5" data-testid="founder-modal-body">
            {FOUNDER_STORY.paragraphs.map((p, i) => (
              <p
                key={i}
                className="text-base sm:text-lg leading-relaxed"
                style={{ color: "var(--ss-ink-2)" }}
                data-testid={`founder-paragraph-${i}`}
              >
                {p}
              </p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
